import { render } from "./FlexLayouts.vue?vue&type=template&id=5ae46474"
import script from "./FlexLayouts.vue?vue&type=script&lang=ts"
export * from "./FlexLayouts.vue?vue&type=script&lang=ts"
script.render = render

export default script